import {Component, inject, OnInit, ViewChild} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {NgForm} from "@angular/forms";
import {Sincronizador} from "../../services/sincronizacao/Sincronizador";
import {AlertController, ModalController, ToastController} from "@ionic/angular";
import {IRepository} from "../../services/persist/IRepository";
import {FaunaDataSource} from "../../services/persist/FaunaDataSource";
import {EntityTarget} from "typeorm/browser/common/EntityTarget";
import {Comportamento} from "../../domain/Comportamento";
import {SQLiteService} from "../../services/sqlite.service";
import {Entidade} from "../../domain/Entidade";
import {EnumSincronizacao} from "../../domain/EnumSincronizacao";

@Component({
    selector: 'app-edit-abstract-hibernate',
    template: '',
    styles: ['']
})
export abstract class AbstractEditOrmComponent<T extends Entidade> implements OnInit {
    router: Router
    route: ActivatedRoute
    entidade: T = {}  as T
    sincronizador: Sincronizador
    toast: ToastController
    abstract agenciavel : boolean
    alert: AlertController
    @ViewChild("form")
    entidadeForm?: NgForm
    dialogo = false
    modalCtrl: ModalController
    abstract urlListagem: string
    relations: string[] = []


    comportamento?: Comportamento

    novaEntidade(): T{
      const obj = this.agenciavel ? {agencia_sigla: this.getSiglaAgencia()} : {}
      return obj as T
    }

    getSiglaAgencia(): string {
      return localStorage.getItem("agencia")!!
    }

  compareWith(o1: any, o2: any) {
    return o1 && o2 ? o1.id === o2.id : o1 === o2;
  }

    novo = false

    get deletavel(): boolean {
        return !this.novo
    }

    _service?: IRepository<any>
    abstract target: EntityTarget<any>

    get service(): IRepository<any>{
      if(this._service == undefined)
        this._service = this.ds.getRepository(this.target)
      return this._service
    }
    ds: FaunaDataSource
    sqlite: SQLiteService

    public constructor() {
        this.ds = inject(FaunaDataSource)
        this.router = inject(Router)
        this.route = inject(ActivatedRoute)
        this.toast = inject(ToastController)
        this.alert = inject(AlertController)
        this.sincronizador = inject(Sincronizador)
        this.modalCtrl = inject(ModalController)
        this.sqlite = inject(SQLiteService)
        console.log('iniciando monitoramento da conectividade')
    }

    async voltar(){
      await this.sair(false)
    }

    async sair(salvou: boolean) {
      if(this.dialogo){
        if(salvou)
          await this.modalCtrl.dismiss(this.entidade, 'confirm');
        else
          await this.modalCtrl.dismiss(null, 'cancel');
      } else {
        await this.router.navigateByUrl(this.urlListagem)
        // await this.router.navigate([this.novo ? "../" : "../.."], {relativeTo: this.route});
      }
    }

    async loadEntity(id: any){
      this.entidade = await this.service.findOneOrFail({
        where:{id: id},
        relations: this.relations
      })
      console.log('carregou entidade', this.entidade)
      if(!this.entidade)
          await this.message('Entidade não encontrada', 'erro')
    }

    ngOnInit(): void {
      if(!this.dialogo) {
        const id = this.route.snapshot.paramMap.get('id')!!;
        console.log('id', id)

        this.route.url.subscribe(data => {
          const tipo = data[2].path
          switch (tipo) {
            case 'new' :
              this.entidade = this.novaEntidade()
              this.novo = true
              break
            case 'edit':
              this.loadEntity(id)
              break;
          }
        })
      }
    }

    async delete() {
      const alert = await this.alert.create({
        header : "Confirmação",
        message : "Tem certeza que deseja deletar o objeto?",
        buttons: [
          {
            text: 'Cancelar',
            role: 'cancel'
          },
          {
            text: 'OK',
            role: 'confirm',
            handler: async () => {
              await this.deleteInternal()
            },
          },
        ]
      })
      await alert.present()
    }

    protected async  deleteInternal() {
        try {
            await this.service.delete(this.entidade)
            await this.sqlite.saveToStore()
            await this.sair(true)
            await this.message('Item excluído com sucesso!!', 'ok')
            // this.sincronizador.send().then()

        } catch (e: any) {
            await this.message('Erro ao excluir item!!' + e, 'error')
        }
    }

    protected async message(message: string, tipo = 'ok'|| 'erro'){
      const toast = await this.toast.create({
        message: message,
        duration: 2000,
        // position: "top",
        icon: tipo == 'ok' ? 'checkmark' : 'close-circle'
      });
      await toast.present()
    }

    async save() {
        if (this.entidadeForm?.valid) {
          try {
            await this.saveInternal()
            console.log('salvou interno')
            await this.sair(true)
            await this.message('Registro salvo com sucesso!', 'ok')
            // await this.sincronizador.send()

          } catch (e: any) {
            console.error(e)
            await this.message('Falha ao salvar. '+ e.message, 'erro ' )
          }
        } else {
          await this.message('Campos Inválidos ou não preenchidos', 'error')
        }
    }


    protected async saveInternal(){
        await this.service.save(this.entidade)
        await this.sqlite.saveToStore()
    }
}
